<?xml version="1.0" encoding="UTF-8"?>
<svg id="strokes" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
  <path
    d="m8.125,1H3.74121c-.4834,0-.875.3916-.875.875s.3916.875.875.875h2.27051L1.13086,7.63086c-.34082.3418-.34082.89648,0,1.23828.1709.1709.39551.25586.61914.25586s.44824-.08496.61914-.25586L7.25,3.98828v2.27051c0,.4834.3916.875.875.875s.875-.3916.875-.875V1.875c0-.4834-.3916-.875-.875-.875Z"
    fill="var(--iconPrimary, #222)" stroke-width="0" />
</svg>